import {
  Zap, Layers, Droplets, Wind, MapPin, ShieldCheck, CookingPot, Repeat,
  Box, BadgeCheck, Sparkles, Flower2, Brush, TrendingUp, ThermometerSun,
  Scissors, Store, Network, Building2, Flame, GraduationCap, Package,
  Wrench, MessageCircle, Gauge, Truck, Clock,
} from "lucide-react";

const icons = {
  Zap, Layers, Droplets, Wind, MapPin, ShieldCheck, CookingPot, Repeat,
  Box, BadgeCheck, Sparkles, Flower2, Brush, TrendingUp, ThermometerSun,
  Scissors, Store, Network, Building2, Flame, GraduationCap, Package,
  Wrench, MessageCircle, Gauge, Truck, Clock,
};

export const Icon = ({ name, className = "h-5 w-5" }) => {
  const Cmp = icons[name] || Sparkles;
  return <Cmp className={className} aria-hidden="true" />;
};
